import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { NavItemEnum } from '../constants/routing/NavItems';
// type-safe and exhaustive mapping of NavItem to route patterns
const NAV_ITEM_ROUTES = {
  [NavItemEnum.MARKETING]: ['/marketing/:tab?'],
  [NavItemEnum.SALES]: ['/sales/:tab?'],
  [NavItemEnum.SERVICE]: ['/service/:tab?'],
  [NavItemEnum.CONTENT]: ['/content/:tab?', '/cms/:tab?'],
  [NavItemEnum.OPERATIONS]: ['/operations/:tab?'],
  [NavItemEnum.DATA]: ['/data/:tab?'],
  [NavItemEnum.SUITE]: ['/suite/:tab?', '/splash/:tab?'],
  [NavItemEnum.SMART_CRM]: ['/smart-crm/:tab?'],
  [NavItemEnum.FREE]: ['/crm'],
  [NavItemEnum.COMMERCE]: ['/commerce'],
  [NavItemEnum.ADD_ONS]: ['/add-ons'],
  [NavItemEnum.BUNDLE]: ['/bundle'],
  [NavItemEnum.MARKETING_PLUS]: ['/marketing-plus'],
  [NavItemEnum.RECOMMENDED]: ['/recommended'],
  [NavItemEnum.BREEZE_INTELLIGENCE]: ['/breeze-intelligence'],
  [NavItemEnum.HUBSPOT_CREDITS]: ['/hubspot-credits'],
  [NavItemEnum.CMS]: ['/cms/:tab?']
};
export const useCurrentNavItem = () => {
  const {
    pathname
  } = useLocation();
  return useMemo(() => {
    // iterate through all nav items in a type-safe way
    for (const [navItem, patterns] of Object.entries(NAV_ITEM_ROUTES)) {
      // check each pattern for this nav item until we find a match
      for (const pattern of patterns) {
        const match = matchPath(pathname, {
          path: pattern,
          exact: false
        });
        if (match) {
          return navItem;
        }
      }
    }
    return null;
  }, [pathname]);
};